import * as React from 'react';
import { StepperCircleProps } from './types';
import { getStepperSizeConfig } from './stepper-config.ts';

const CheckIcon = ({ size }: { size: number }) => {
  const iconSize = Math.max(14, size * 0.6); // Minimum 14px, or 60% of circle size
  return (
    <svg viewBox="0 0 18 18" style={{ width: iconSize, height: iconSize }}>
      <path
        d="M6.75 11.25L4.5 9L3.75 9.75L6.75 12.75L14.25 5.25L13.5 4.5L6.75 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

const XIcon = ({ size }: { size: number }) => {
  const iconSize = Math.max(14, size * 0.6); // Minimum 14px, or 60% of circle size
  return (
    <svg viewBox="0 0 18 18" style={{ width: iconSize, height: iconSize }}>
      <path
        d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export function StepperCircle({ state, size, stepperSize = 'md' }: StepperCircleProps) {
  const sizeConfig = getStepperSizeConfig(stepperSize);
  const circleSize = size || sizeConfig.circleSize;
  const getCircleClasses = () => {
    switch (state) {
      case 'inactive':
        return 'text-muted'; // Muted text, background will be set inline
      case 'active':
        return 'bg-primary text-white'; // Primary background, white text
      case 'complete':
        return 'bg-success text-white'; // Success (green) background, white text
      case 'incomplete':
        return 'bg-danger text-white'; // Danger (red) background, white text
      default:
        return 'text-muted';
    }
  };

  const getInlineStyles = () => {
    if (state === 'inactive') {
      return { backgroundColor: '#e9ecef' }; // Light grey for inactive state
    }
    return {};
  };

  return (
    <div
      className={`d-flex align-items-center justify-content-center rounded-circle position-relative ${getCircleClasses()}`}
      style={{
        width: circleSize,
        height: circleSize,
        ...getInlineStyles(),
      }}
    >
      {state === 'complete' && <CheckIcon size={circleSize} />}
      {state === 'incomplete' && <XIcon size={circleSize} />}
    </div>
  );
}